import React, {Key, useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';

const FadeAnimation: React.FC<{customTrigger?: Key}> = ({customTrigger}) => {
    const location = useLocation();
    const [trigger, setTrigger] = useState((new Date).getMilliseconds());

    useEffect(() => {
       setTrigger((new Date).getMilliseconds())
    }, [location]);

    return <div key={customTrigger || trigger} className={"animation-fade absolute top-0 z-50 h-screen bg-gray-900 w-full active"}/>;
};
export default FadeAnimation;
